import { z } from 'zod';

export const programRecommendationsSchema = z
  .array(
    z.object({
      key: z.string(),
    })
  )
  .transform((data) => data.map((item) => item.key));

export type ProgramRecommendationsResponse = z.input<typeof programRecommendationsSchema>;
export type ProgramRecommendations = z.infer<typeof programRecommendationsSchema>;
